import { Typography } from '../kit';
import { themeColors } from '../theme/theme';

export default function SummaryCard({ origin, destination, parcelType, parcelWeight }) {
  return (
    <div
      style={{
        background: '#fff',
        borderRadius: 16,
        boxShadow: `0 2px 12px ${themeColors.primaryColor}11`,
        padding: '1.5em 1em',
        margin: '1.5em 0',
        maxWidth: 420,
        marginLeft: 'auto',
        marginRight: 'auto',
        position: 'relative',
      }}
    >
      <Typography
        type="h3"
        text="Summary"
        style={{
          color: themeColors.primaryColor,
          fontWeight: 700,
          marginBottom: 16,
          fontSize: 22,
        }}
      />
      <Typography
        type="text"
        text={`Pickup: ${origin?.building || ''}, ${origin?.landmark || ''}`}
        style={{ marginBottom: 6 }}
      />
      <Typography
        type="text"
        text={`Dropoff: ${destination?.building || ''}, ${destination?.landmark || ''}`}
        style={{ marginBottom: 6 }}
      />
      <Typography
        type="text"
        text={`Contact: ${origin?.contact || ''}`}
        style={{ marginBottom: 6 }}
      />
      <Typography
        type="text"
        text={`Parcel Type: ${parcelType || ''}`}
        style={{ marginBottom: 6 }}
      />
      <Typography
        type="text"
        text={`Weight/Volume: ${parcelWeight || ''}`}
        style={{ marginBottom: 6 }}
      />
    </div>
  );
}
